<template>
  <modal id="add-login-modal">
    <div class="add-login-modal">
      <h2 class="add-login-modal__headline">
        {{ $t("headline") }}
      </h2>
      <div class="add-login-modal__email">
        <label for="change-email">
          {{ $t("emailAddress") }}
        </label>
        <div class="form__field-container">
          <input class="form__input" id="change-email" v-model="email" type="email" />
        </div>
      </div>

      <div class="add-login-modal__password">
        <label>{{ $t("password") }}</label>
        <show-password v-model="password" :placeholder="$t('createPassword')" />
      </div>

      <div class="add-login-modal__buttons">
        <a class="add-login-modal__cancel" @click="close">
          {{ $t("cancel") }}
        </a>
        <button class="add-login-modal__button button" @click="submit">
          {{ $t("save") }}
        </button>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "@/shared/modal"
import events from "@/bl-events/index"
import ShowPassword from "@/shared/show-password.vue"

/**
 * @emits submit
 */
export default {
  name: "AddLoginModal",
  components: {
    Modal,
    ShowPassword
  },
  data: () => ({
    email: "",
    password: ""
  }),
  methods: {
    close() {
      events.emit("modal:add-login-modal:close")
    },
    submit() {
      this.close()
      this.$emit("submit", {
        email: this.email,
        password: this.password
      })
    }
  },
  i18n: {
    messages: {
      en: {
        headline: "Link email login details",
        emailAddress: "Email address",
        password: "Password",
        createPassword: "Create password",
        cancel: "Cancel",
        save: "Add"
      },
      de: {
        headline: "Neue E-Mail-Adresse hinzufügen",
        emailAddress: "E-Mail-Adresse",
        password: "Passwort",
        createPassword: "Passwort anlegen",
        cancel: "Abbrechen",
        save: "Hinzufügen"
      }
    }
  }
}
</script>

<style lang="scss">
.add-login-modal {
  justify-content: flex-end;
  margin-right: 0;
  margin-left: 0;
  padding: $basex2;

  border-radius: $spacing-4;

  &__headline {
    @include font-style(h3);

    margin-top: $basex6;
    margin-bottom: $basex3;
  }

  &__email {
    @include font-style(h5);

    margin-bottom: $basex4;

    color: $mid-grey;
  }

  &__password {
    @include font-style(h5);

    margin-bottom: $basex4;

    color: $mid-grey;
  }

  &__cancel {
    margin-right: $basex2;

    color: $mid-grey;
  }

  &__buttons {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  @include media(min-width, m) {
    width: $x-wide-block-width;
  }
}
</style>
